export const DateTimeFormat = {
    IsoDate: 'YYYY-MM-DD',
    IsoDateTime: 'YYYY-MM-DD HH:mm:ss',
}

export const DateTimeFormatCode  = {
    DateTime: 'DATETIME',
    LongDate: 'LONGDATE',
    ShortDate: 'SHORTDATE',
    Time: 'TIME',
    InputDate: 'INPUTDATE'
}

export const DateTimeFormatCodes = [
    DateTimeFormatCode.DateTime, 
    DateTimeFormatCode.LongDate, 
    DateTimeFormatCode.ShortDate,
    DateTimeFormatCode.Time, 
    DateTimeFormatCode.InputDate
];
